import React, { useEffect, useState } from 'react'

import { TabButton, TabContent, TabHeader, TabWrapper } from './styles'
import { ITabProps } from './types'

function Tab({
	tabs,
	activeIndex,
	defaultActiveIndex = 0,
	onChange,
	className,
}: ITabProps) {
	const isControlled = typeof activeIndex === 'number'
	const [internalIndex, setInternalIndex] = useState<number>(defaultActiveIndex)

	const currentIndex = isControlled ? (activeIndex as number) : internalIndex

	useEffect(() => {
		if (isControlled) return
		if (defaultActiveIndex >= tabs.length) {
			setInternalIndex(0)
		}
	}, [tabs.length, defaultActiveIndex, isControlled])

	function handleSelectTab(index: number, disabled?: boolean) {
		if (disabled) return
		if (!isControlled) setInternalIndex(index)
		onChange?.(index)
	}

	if (!tabs.length) return null

	const safeIndex = currentIndex >= 0 && currentIndex < tabs.length ? currentIndex : 0
	const activeTab = tabs[safeIndex]

	return (
		<TabWrapper className={className}>
			<TabHeader role='tablist'>
				{tabs.map((tab, index) => {
					const isActive = index === safeIndex
					return (
						<TabButton
							key={`${tab.label}-${index}`}
							type='button'
							role='tab'
							aria-selected={isActive}
							disabled={tab.disabled}
							isActive={isActive}
							onClick={() => handleSelectTab(index, tab.disabled)}
						>
							{tab.label}
						</TabButton>
					)
				})}
			</TabHeader>
			<TabContent role='tabpanel'>{activeTab.content}</TabContent>
		</TabWrapper>
	)
}

export default Tab
